import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { sendContactMessage } from "../Data/dataApi";
import "../Css/contactform.css";
import { Helmet } from "react-helmet-async";

const ContactForm: React.FC = () => {
  const { t } = useTranslation();

  const [isSuccess, setIsSuccess] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      toast.error(t("contact.error_required"));
      return;
    }

    try {
      setLoading(true);

      const result = await sendContactMessage(form);

      if (!result.success) {
        throw new Error(result.message);
      }

      toast.success(t("contact.success"));

      setIsSuccess(true);

    } catch (err: any) {
      console.error(err);
      toast.error(err.message || t("contact.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Contact us | Stockifly
        </title>

        <meta
          name="description"
          content="Contact form of Stockifly"
        />
      </Helmet>

      <div className="contact-container">

        {isSuccess ? (
          <div className="contact-success">
            <h2>✅ {t("contact.successTitle")}</h2><br />
            <p>{t("contact.successMessage")}</p>
          </div>
        ) : (
          <>
            <h2>{t("contact.title")}</h2><br />

            <form onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="name"
                placeholder={t("contact.name")}
                value={form.name}
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                placeholder={t("contact.email")}
                value={form.email}
                onChange={handleChange}
              />

              <textarea
                name="message"
                placeholder={t("contact.message")}
                value={form.message}
                onChange={handleChange}
                rows={6}
              />

              <button type="submit" disabled={loading}>
                {loading ? t("contact.sending") : t("contact.send")}
              </button>
            </form>
          </>
        )}

      </div>
    </>
  );
};

export default ContactForm;